import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import ContactHero from './components/ContactHero';
import ContactMain from './components/ContactMain';

export default function ContactPage() {
  useSEO({
    title: '聯絡我們｜康永生技保健食品代工諮詢',
    description: '聯絡康永生技，提供保健食品 ODM/OEM 代工諮詢服務。地址：台中市北區中清路一段79號6樓，電話：(04)-22029858。',
    keywords: '聯絡康永,保健食品代工諮詢,ODM OEM 聯絡,康永生技聯絡方式',
    lang: 'zh-TW',
    canonicalPath: '/contact',
  });

  return (
    <Layout>
      <SEOJsonLd
        type="WebPage"
        pageTitle="聯絡我們｜康永生技保健食品代工諮詢"
        pageDescription="聯絡康永生技，提供保健食品 ODM/OEM 代工諮詢服務。"
        pageUrl="https://kangyong.com/contact"
      />
      <ContactHero />
      <ContactMain />
    </Layout>
  );
}